import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';

export class ImageSize extends DataModel {
  static readonly TYPE_ID: string = '2bae69fc521047ef87e72f10d11df14d';

  constructor(
    public readonly width: number,
    public readonly height: number,
  ) {
    super();
    this.aspectRatio = width / height;
  }

  public readonly aspectRatio: number;

  get $typeId(): string {
    return ImageSize.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): ImageSize {
    return new ImageSize(
        MapUtils.get<number>(map, 'width'),
        MapUtils.get<number>(map, 'height'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'width': this.width,
      'height': this.height,
      'aspectRatio': this.aspectRatio,
    };
  }

  clone(): this {
    return new ImageSize(
        this.width,
        this.height,
    ) as this;
  }

  isSame(other: ImageSize): boolean {
    if(other === this) {
      return true;
    }

    return other.width === this.width &&
      other.height === this.height &&
      other.aspectRatio == this.aspectRatio;
  }
}

export class ImageSizeBuilder extends DataModelBuilder<ImageSize> {
  build(context: SerializationContext, map: SerializedData): ImageSize {
    return ImageSize.fromMap(context, map);
  }
}
